// Shared helpers for the sign-up and forgot-password screens.

// Number of satisfied rules (0-4) for the password strength meter.
export const getStrength = (password: string | undefined): number => {
  const value = password ?? '';
  return [
    value.length >= 8,
    /\d/.test(value),
    /[^A-Za-z0-9]/.test(value),
    /[a-z]/.test(value) && /[A-Z]/.test(value),
  ].filter(Boolean).length;
};

export const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

// 600 -> "10:00"
export const formatTime = (seconds: number): string =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
